<template>
  <div class="list-message">
    <div class="container-fluid" v-show="currentTab == 'list'">
      <div class="row filter-row">
        <div class="col-12">
          <h5>Filtros</h5>
        </div>
        <div class="col-lg-4 col-12">
          <div class="form-group">
            <input type="text" v-model="filter.name" placeholder="Mensagem" class="form-control" />
          </div>
        </div>
        <div class="col-lg-2 col-12">
          <button class="btn btn-primary" v-on:click="filterTable()">Pesquisar</button>
        </div>
        <div class="col-lg-6 col-12">
          <button class="btn btn-primary float-right" v-on:click="newMessage()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
            hover
            :fields="fields"
            :items="data"
            :per-page="0"
            :current-page="currentPage"
            @row-clicked="selectItemTable"
          >
           <template v-slot:cell(created_at)="data">{{formatDate(new Date(data.value))}}</template>
          </b-table>
          
          <div class="no-data" v-if="data.length == 0">
            <span>Sem dados</span>
          </div>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-show="currentTab == 'message'">
      <message-form ref="message_component" :reported_error_id="reported_error_id"  @back="backToList()"></message-form> 
      <!-- <client-user-component ref="client_component" :client_id="client_id" @back="backToList()"></client-user-component> -->
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import MessageForm from "@/components/errors/MessageForm";
import moment from "moment";

export default {
  name: "list-message",
  props: {
    reported_error_id: Number,
  },
  components:{
    MessageForm
  },
  data() {
    return {
      currentTab: "list",
      perPage: 6,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "created_at", label: "Data" },
        { key: "message", label: "Mensagem" },
      ],
      filter: {
        message: ""
      }
    };
  },
  mounted() {
    this.providerData();
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/reported_error_message?${this.urlBuild()}`)
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
        });
    },
    urlBuild: function() {
      let url =
        "include=contact&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        "&sort=order" +
        `&filter[reported_error_id]=${this.reported_error_id}` +
        (this.filter.message != "" ? `&filter[message]=${this.filter.message}` : "");
      return url;
    },
    selectItemTable: function(record, index) {
      this.$refs.message_component.editMessage(record);
      this.newMessage();
    },
    backToList: function() {
      this.filter.name = "";
      this.filterTable();
      this.currentTab = "list";
    },
    newMessage: function(){
      this.currentTab = "message";
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>

<style>
</style>
